import { useEffect, useRef, useLayoutEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import gsap from 'gsap'
import './contact.css'

import Nav from '../Nav/Nav'
import Sidebar from '../Sidebar/Sidebar'
import Footer from '../Footer/Footer'
import ContactForm from './ContactForm'

import {GoLocation} from 'react-icons/go'
import {AiOutlinePhone} from 'react-icons/ai'
import {AiOutlineMail} from 'react-icons/ai'


const Contact = ({sidebarIsOpen, setSidebarIsOpen}) =>
{
    // Refs
    const overlayRef = useRef()
    const titleRef = useRef()
    const subRef = useRef()

    // Close sidebar
    useEffect(()=>{
        setSidebarIsOpen(false)
    },[])

    useLayoutEffect(()=>{
        window.scrollTo({
            top:0,
            left:0,
            behavior:'smooth'
        })
    },[])

    // Animations on load
    useEffect(()=>{
        gsap.to(overlayRef.current, {duration:1, scaleX:0, transformOrigin: 'right', ease: "expo.in"})
        gsap.fromTo(titleRef.current, {y: 500}, {delay:1, duration:0.3, y:0, ease: "expo.out"})
        gsap.fromTo(subRef.current, {y: 500}, {delay:1.2, duration:0.3, y:0, ease: "expo.out"})
    },[])

    return(
        <div className="contact">
            <Helmet>
                <title>Antino Kila - Contact me</title>
                <meta name='description' content='This is Antino Kila, a creative frontend developer based in United Kingdom.' />
            </Helmet>

            <div className="contact-overlay" ref={overlayRef}></div>

            <Nav sidebarIsOpen={sidebarIsOpen} setSidebarIsOpen={setSidebarIsOpen} />
            {sidebarIsOpen? <Sidebar /> : ""}   

            <h1 ref={titleRef}>Let's talk</h1>
            <p ref={subRef} className='contact-p'>Tell me about your <span>ideas</span> and we can make it <span>happen</span>
            . I'll make sure to get back as soon as possible.</p>
            
            {/* <ContactForm /> */}

            <div className='contact-alternative'>
                <p>Mail me at</p>
                <Link to="#" className='contact-email' onClick={() => window.location.href = 'mailto:antinokdev@gmail.com'}><AiOutlineMail /> antinokdev@gmail</Link>
            </div>
    
            <div className="contact-details">
                {/* <div>
                    <AiOutlinePhone />
                    <span>+44 07308028605</span>
                </div> */}

                <div>
                    <GoLocation />
                    <span>Leicester, United Kingdom</span>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default Contact